import React, { useEffect } from 'react';
import './registro.css';

const Registro = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container container-mh">

      <div className="row">

        <div className="col-12">
          <h1 className="title">Proveedores</h1>
          <hr className="hr-gob" />
        </div>


        <div className="col-12">

          <section className="registro-aviso-card">

            <div className="registro-franja-superior">
              <span className="franja-vino"></span>
              <span className="franja-dorada"></span>
            </div>


            <div className="registro-icono-principal">
              <img
                src="/assets/imgs/oficina_virtual/Inscrip.Prove..png"
                alt="Inscripción en el padrón de proveedores"
              />
            </div>


            <h2 className="registro-titulo">
              Inscripción en el padrón de
              <br />
              Proveedores del Estado de Hidalgo
            </h2>


            <div className="registro-importante">
              <i className="fa-solid fa-triangle-exclamation"></i>
              <span>AVISO IMPORTANTE</span>
            </div>


            <p className="registro-descripcion">
              Las personas físicas y morales interesadas en registrarse deberán
              enviar la documentación requerida al correo electrónico:
            </p>


            <div className="registro-contactos">

              <a
                href="mailto:padronessc@hidalgo.gob.mx"
                className="registro-contacto"
              >
                <div className="registro-contacto-icono vino">
                  <i className="fa-regular fa-envelope"></i>
                </div>

                <div className="registro-contacto-texto">
                  <span>Correo electrónico</span>

                  <strong>
                    padronessc@hidalgo.gob.mx
                  </strong>
                </div>
              </a>


              <div className="registro-contacto">

                <div className="registro-contacto-icono dorado">
                  <i className="fa-regular fa-clock"></i>
                </div>

                <div className="registro-contacto-texto">
                  <span>Horario de atención</span>

                  <strong>
                    8:30 a.m. a 4:30 p.m.
                  </strong>
                </div>

              </div>


              <a
                href="tel:7717183497"
                className="registro-contacto"
              >

                <div className="registro-contacto-icono vino">
                  <i className="fa-solid fa-phone"></i>
                </div>

                <div className="registro-contacto-texto">
                  <span>Teléfono</span>

                  <strong>
                    771 718 3497
                  </strong>
                </div>

              </a>

            </div>


            <div className="registro-consultas">

              <i className="fa-solid fa-circle-info"></i>

              <span>
                Para cualquier consulta también puede escribir a
              </span>

              <a href="mailto:agenda.padron@hidalgo.gob.mx">
                agenda.padron@hidalgo.gob.mx
              </a>

            </div>


            <div className="registro-separador">

              <span></span>

              <i className="fa-solid fa-leaf"></i>

              <span></span>

            </div>


            <div className="registro-gracias">

              <div className="registro-gracias-icono">
                <i className="fa-regular fa-heart"></i>
              </div>

              <span>
                Agradecemos su atención y comprensión.
              </span>

            </div>

          </section>

        </div>

      </div>

    </div>
  );
};

export default Registro;